import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import PageLayout from "../components/layout/PageLayout";
import api from "../lib/api";
import { Check, X } from "lucide-react";

export function PaymentSuccess() {
    const [params] = useSearchParams();
    const sid = params.get("session_id");
    const [status, setStatus] = useState(null);

    useEffect(() => {
        if (!sid) return;
        let stopped = false;
        let attempts = 0;
        const poll = async () => {
            if (stopped) return;
            try {
                const { data } = await api.get(`/payments/status/${sid}`);
                setStatus(data);
                if (data.payment_status !== "paid" && attempts < 20) {
                    attempts += 1;
                    setTimeout(poll, 2000);
                }
            } catch (err) {
                console.error("Payment status poll error:", err);
                if (attempts < 20) {
                    attempts += 1;
                    setTimeout(poll, 2000);
                }
            }
        };
        poll();
        return () => { stopped = true; };
    }, [sid]);

    return (
        <PageLayout>
            <section className="pt-32 pb-32">
                <div className="max-w-2xl mx-auto px-5 text-center" data-testid="payment-success">
                    <div className="w-20 h-20 border-2 border-[#d4af37] flex items-center justify-center mx-auto">
                        <Check size={32} className="text-[#d4af37]" />
                    </div>
                    <h1 className="font-display text-5xl text-white mt-8 tracking-tight">
                        {status?.payment_status === "paid" ? "PAYMENT CONFIRMED" : "PROCESSING PAYMENT…"}
                    </h1>
                    <p className="text-white/60 mt-6">
                        {status?.payment_status === "paid"
                            ? "Thank you. Your enrollment is confirmed and access details will follow shortly."
                            : "We're confirming your payment with Stripe. This usually takes a few seconds."}
                    </p>
                    {status && <div className="text-white/40 text-xs mt-6 font-mono">Session: {sid}</div>}
                    <Link to="/" className="btn-outline mt-10 inline-flex" data-testid="payment-home">Back to Home</Link>
                </div>
            </section>
        </PageLayout>
    );
}

export function PaymentCancel() {
    return (
        <PageLayout>
            <section className="pt-40 pb-32">
                <div className="max-w-2xl mx-auto px-5 text-center" data-testid="payment-cancel">
                    <div className="w-20 h-20 border-2 border-white/20 flex items-center justify-center mx-auto">
                        <X size={32} className="text-white/50" />
                    </div>
                    <h1 className="font-display text-5xl text-white mt-8 tracking-tight">PAYMENT CANCELLED</h1>
                    <p className="text-white/60 mt-6">No charge was made. You can try again anytime.</p>
                    <Link to="/academy" className="btn-outline mt-10 inline-flex" data-testid="payment-back-academy">Back to Academy</Link>
                </div>
            </section>
        </PageLayout>
    );
}
